<template>
    
    <div id="login">

        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :xs="22" :sm="10" :md="8" class="titulo">
                Ingresar
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :xs="24" :sm="10" class="cuerpo">

                <!--
                <el-col :xs="24" :sm="8">
                    <center>
                        <a 
                            class="logocuestionario"
                            href="https://cuestionario.educaciondigitaltuc.gob.ar" 
                            style="margin-bottom:30px"
                        >
                            <img src="../assets/Banner_Artes_2.jpeg" 
                            style="width:100%"/></a>
                        <br><br><br>
                    </center>
                </el-col>
                -->


                <el-col :xs="24" :sm="24">

                    <!-- Alerta -->
                    <v-alert
                        v-if="error"
                        type="error"
                        :value="true"
                        style="margin-bottom:30px"
                        color="red">
                        Usuario o Contraseña Incorrecto
                    </v-alert>
                    <v-alert
                        v-if="problema"
                        type="error"
                        :value="true"
                        style="margin-bottom:30px"
                        color="red">
                        Ha ocurrido un error intentando procesar su solicitud. Por favor, intente mas tarde.
                    </v-alert>



                    <el-form ref="f" :model="f" :rules="rules">


                        <!-- Formulario -->
                        <el-form-item prop="username" v-if="mostrar">
                            <el-input type="text" ref="Username" v-model="f.username" placeholder="Ingrese su DNI sin puntos" @paste.prevent @keypress.native="control($event)" maxlength="8">
                                <template slot="prepend"><img src="https://docentes.educaciondigitaltuc.gob.ar/assets/face.svg"/></template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password" v-if="mostrar">
                            <el-input type="password" v-model="f.password" placeholder="Ingrese su Contraseña" @paste.prevent @keypress.native="control2($event)">
                                <template slot="prepend"><img src="https://docentes.educaciondigitaltuc.gob.ar/assets/lock.svg"/></template>
                            </el-input>
                        </el-form-item>


                        <!-- Re-Captcha -->
                        <div style="float:right" v-if="mostrar">
                            <vue-recaptcha 
                                ref="recaptcha"
                                size="normal"
                                sitekey="6LcFEH4aAAAAAIbFqQzBOaOPYHU8s25Xk9K9F-cx"
                                @verify="onVerify"
                                @expired="onExpired"
                                :loadRecaptchaScript="true"
                            ></vue-recaptcha>
                        </div>
                        <div style="float:right; text-align:right; padding:10px; margin-bottom:20px" v-if="mostrar">
                            <button class="BtnA" style="font-size:small" @click="resetRecaptcha">Reset ReCAPTCHA </button>
                        </div>
                        


                        <!-- Botones -->
                        <el-form-item style="margin-top:130px !important" v-if="mostrar">
                            <v-col class="col-12">
                                <v-btn 
                                    raised 
                                    block
                                    color="blue" 
                                    :loading="cargando" 
                                    :disabled="!verificado"
                                    @click="submitForm('f')"
                                    style="color:#fff"
                                >
                                    Ingresar
                                </v-btn>
                            </v-col>
                        </el-form-item>                    
                       
                        <el-form-item style="margin-top:20px !important"  v-if="mostrar">
                            <router-link :to="'recuperar'" class="el-col el-col-24 el-button"               >Recuperar Contraseña</router-link>
                        </el-form-item>                      
                    </el-form>
                </el-col>

            </el-col>
        </el-row>
    </div>
</template>



<script>
    import axios        from 'axios';
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        data() {
            sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

            return {
                cargando:       false,
                error:          false,
                problema:       false,
                verificado:     false,

                Usuario:        [],
                Comisiones:     [],
                mostrar:        true,
                f: {
                    username:   '',
                    password:   '',
                },
                rules: {
                    username: [
                        { required: true, message: 'Por favor, ingrese su DNI', trigger: 'blur' },
                        { min: 7, max: 8, message: 'Documento Inválido', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: 'Por favor, ingrese su contraseña', trigger: 'blur' },
                        { min: 3, message: 'Mínimo 3 letras', trigger: 'blur' }
                    ]
                },

                Headers: [
                    {   text: 'Capacitación ',
                        value: 'Nombre'
                    },
                    {   text: 'Fecha de Inicio ',
                        value: 'Fecha'
                    },
                    {   text: 'Lugar ',
                        value: 'Lugar'
                    },
                    {   text: 'Campus Virtual ',
                        value: 'Campus'
                    }
                ],
            }
        },



        components: {
            'vue-recaptcha': VueRecaptcha
        },
  

  
        methods: {
            onVerify: function (response) 
            {   this.verificado = true;
            },
            onExpired: function () 
            {   this.$refs.recaptcha.reset();
            },
            resetRecaptcha () 
            {   this.$refs.recaptcha.reset();
            },             
            control(e)
            {   if( (e.which>31 & e.which<48) || e.which>57) { e.preventDefault(); }    // Campo numerico
            },
            control2(e)
            {   if(e.keyCode === 13) 
                {   this.submitForm('f');               // Envia apretando el Enter 
                }   
                else
                {   if( (e.which>32  && e.which<48)  ||
                        (e.which>57  && e.which<65)  ||
                        (e.which>90  && e.which<97)  ||
                        (e.which>123 && e.which<209) ||
                        (e.which>209 && e.which<241) ||
                        (e.which>241)
                    )
                    { e.preventDefault(); }
                }
            },
            submitForm(formName)
            {   
                
                this.cargando   = true;
                this.error      = false;
                this.problema   = false;
                this.$refs[formName].validate((valid) => {
                    if (valid)
                    {   var params  = '';
                        var headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');

                        params = params + 'username=' + this.f.username;
                        params = params + '&password=' + this.f.password;
                        
                        axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/lg_in.php', params, {headers: headers})
                            .then(response => {
                                const datos                     = response.data;

                                if(datos['token'])
                                {   this.$cookies.set("PDTK",       datos['token'],     "1h");
                                    this.$cookies.set("PDVisitas",  datos['Visitas'],   "1h");
                                   window.location.href    = 'home';
                                   
                                }
                                else
                                {   if(datos['Mensaje']=='usuario')
                                    {   this.error          = true;
                                        this.cargando       = false;
                                    }
                                    else
                                    {   this.problema       = true;
                                        this.cargando       = false;
                                    }
                                    
                                }
                            })
                            .catch(e => {
                                this.problema                   = true;
                                this.cargando                   = false;
                            })
                    }
                })
            }
        },


        mounted()
        {   this.$nextTick(this.$refs.Username.focus);
        }
    };
</script>
<style>
    .logocuestionario img
    {   background-color: #fff;
        border: 1px solid #ccc;
        padding: 5px;
        border-radius: 5px;
        -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
    }

    .logocuestionario img:hover
    {   -webkit-box-shadow: 0px 5px 10px 0px rgba(50, 50, 50, 0.75);
        -moz-box-shadow:    0px 5px 10px 0px rgba(50, 50, 50, 0.75);
        box-shadow:         0px 5px 10px 0px rgba(50, 50, 50, 0.75);
        -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
    }
</style>